export default {
  IsoDuration: {
    maxDurationError: 'Ошибка валидации. Максимальное значение таймера - {{data}}',
  },
  viewClientPagesButton: {
    seeAsClient: 'Посмотреть ЛК',
    backToProfile: 'Назад в Профиль',
  },
  neverViewButton: {
    label: 'Больше не показывать',
    cancelButton: 'Не скрывать',
    submitButton: 'Скрыть',
  },
};
